import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useCanManageExternalIntegration from "shared/ExternalIntegration/access/useCanManageExternalIntegration";
import { ExternalIntegration } from "types/generated";

import IntegrationActionDropdown from "../../ItemPage/ActionDropdown";

const ServiceNowTableDropdownCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ExternalIntegration>) => {
  const canManageExternalIntegration = useCanManageExternalIntegration();
  const canManageIntegration = canManageExternalIntegration(integration);

  return (
    <TableSimpleCell {...cellProps}>
      <IntegrationActionDropdown
        integration={integration}
        canManageIntegration={canManageIntegration}
        refetchQueriesOnDelete={["GetAccountExternalIntegrations"]}
      />
    </TableSimpleCell>
  );
};

export default ServiceNowTableDropdownCell;
